// src/App.js
import React from 'react';
import { ChakraProvider } from "@chakra-ui/react";
import theme from './theme';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import InputForm from './components/InputForm';
import AdminPanel from './components/admin/AdminPanel'; // パスを修正

function App() {
  return (
    <ChakraProvider theme={theme}>
      <Router>
        <Routes>
          <Route path="/" element={<InputForm />} />
          <Route path="/admin" element={<AdminPanel />} />
        </Routes>
      </Router>
    </ChakraProvider>
  );
}

export default App;